import { action } from 'services/utils';

import { MAIN_ACTION } from './main.constants';
import { IMainRedux } from './main.typing';

const { CLEAR, SET_SHOW_BOTTOM_BAR, OPEN_TEST, CLOSE_TEST, UPDATE } =
  MAIN_ACTION;

export const MainActions = {
  clear: () => action(CLEAR),

  openTest: () => action(OPEN_TEST),

  closeTest: () => action(CLOSE_TEST),

  setShowBottomBar: (isShowBottomBar: boolean) =>
    action(SET_SHOW_BOTTOM_BAR, isShowBottomBar),

  update: (payload: Partial<IMainRedux>) => action(UPDATE, payload),
};

export type TMainActions = ReturnType<TActionCombiner<typeof MainActions>>;
